export const config = { useSystemColorMode: false, initialColorMode: "system" };
